export default __webpack_public_path__ + "static/media/DashIcon.f56ef6d6.svg";